import classNames from 'classnames'
import React from 'react'
import styles from './style.styl'

const PremiumOverlay = ({ className, style, children }) => (
  <div className={classNames('PremiumOverlay', className)} style={style}>
    {children}
    <div className="PremiumOverlay__Banner">
      Upgrade
    </div>
  </div>
)

export default PremiumOverlay



// WEBPACK FOOTER //
// ./src/scripts/components/shared/PremiumOverlay/index.js